import React, { useState, useRef } from 'react'
import { Link } from "react-router-dom"
import { subscribeNow } from "./GeneralServices/GeneralServices"
import { Toast } from 'primereact/toast';
const FooterComponent = () => {
    const [email, setEmail] = useState("")
    const toast = useRef(null);
    const onSubscribe = (e) => {
        e.preventDefault()
        subscribeNow({ email }).then(res => {
            if (res.data.success) {
                setEmail("")
                toast.current.show({ severity: 'info', summary: 'Success', detail: 'Thanks for Subscribing Infomed', sticky: false });
            }
        }).catch(er => {
            console.log(er)
        })
    }
    return (
        <footer id="footer">
            <Toast ref={toast} />
            <div className="footer-top">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-3 col-md-6 footer-contact">
                            <img src="images/white_logo.png" />
                            <p>
                                Unit A-3-3 (Block A, Arena Mentari). <br />
                            No. 1 Jalan PJS 8/15, <br />
                            Dataran Mentari, <br />
                            46150 Petaling Jaya, Selangor, Malaysia
                            <br />
                                <strong>Phone:</strong> +603 – 5613 5587<br />
                                <strong>Email:</strong><Link to="/contact-us"> enquiry@infomed.com.my</Link><br />
                            </p>
                        </div>


                        <div className="col-lg-5 col-md-6 footer-links">
                            <ul>

                                <li><i className="fas fa-angle-right"></i>
                                    <Link to="/about-us">About Us</Link>

                                </li>
                                <li><i className="fas fa-angle-right"></i>
                                    <Link to="/contact-us">Contact Us</Link></li>
                                <li><i className="fas fa-angle-right"></i>
                                    <Link to="/editorial-board">Meet InfoMed Editorial Board</Link></li>

                                <li><i className="fas fa-angle-right"></i>
                                    <Link to="/media-kit">Advertise & Media Kit</Link>

                                </li>
                                <li><i className="fas fa-angle-right"></i>
                                    <Link to="/partners-withus">Partner with Us</Link>
                                </li>
                                <li><i className="fas fa-angle-right"></i>
                                    <Link to="/editorial-terms">Editorial Terms & Conditions</Link>

                                </li>
                                <li><i className="fas fa-angle-right"></i>
                                    <Link to="/privacy">Privacy</Link>

                                </li>
                                <li><i className="fas fa-angle-right"></i>
                                    <Link to="/policy-comments">Policy on Comments</Link>
                                </li>
                                <li><i className="fas fa-angle-right"></i>
                                    <Link to="/data-protection">Personal Data Protection Notice</Link>
                                </li>
                            </ul>
                        </div>

                        <div className="col-lg-4 col-md-6 footer-newsletter">
                            <h4>Join Our Newsletter</h4>
                            <p>Embracing global healthcare challenges</p>
                           <p> InfoMed is the leading independent source for news on all aspects of the healthcare industry. We are enabling our readers to be knowledgeable and be involved in their healthcare.
                            </p>
                        </div>

                    </div>
                </div>
            </div>


            <div className="container d-md-flex py-2">

                <div className="mr-md-auto text-center text-md-left">
                    <div className="copyright">
                        2021&copy; Copyright <strong><span>InfoMed</span></strong>. All Rights Reserved
        </div>
                </div>
                <div className="social-links text-center text-md-right pt-3 pt-md-0">
                    <a  href="https://twitter.com/InfoMedMagazine" target="_blank" className="twitter"><i className="fab fa-twitter"></i></a>
                    <a href="https://www.facebook.com/InfomedMalaysia/" target="_blank"  className="facebook"><i className="fab fa-facebook-f"></i></a>
                    <a href="https://www.linkedin.com/company/infomed-malaysia/about/" target="_blank"  className="linkedin"><i className="fab fa-linkedin-in"></i></a>
                </div>
            </div></footer>
    )
}
export default FooterComponent





